"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var UpdateProfileForm_1 = require("./UpdateProfileForm");
var UpdateProfileButton = function (props) {
    var formRef = react_1.useRef();
    var buttonLabel = props.buttonLabel, className = props.className;
    var _a = react_1.useState(false), modal = _a[0], setModal = _a[1];
    var toggle = function () { return setModal(!modal); };
    /*
        console.log(props.data);
        const [email, setEmail] = useState(props.data.email)
        function handleEmailChange(evt) {
           setEmail(evt.target.value)
            console.log(email)
        }
    */
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { color: "", onClick: toggle }, props.children),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Update Profile"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(UpdateProfileForm_1.default, { id: props.id, modalCallback: toggle, ref: formRef })),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return formRef.current.submitForm(); } }, "Update Profile")))));
};
exports.default = UpdateProfileButton;
//# sourceMappingURL=UpdateProfileButton.js.map